/*
 * Copyright (c) 2015 - 2021 by KAA Soft. All rights reserved.
 */
import { adminConfig } from "../adminConfig";
import { getBookAuthors, getMoreBtn } from "./book";
import { simpleSelectInit } from "./customSelects";
import { notification } from "./utils/notification";
export function borrowingInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var borrowingFormElements = container.querySelectorAll(".borrowing-request");
  for (var i = 0; i < borrowingFormElements.length; i++) {
    borrowingForm(borrowingFormElements[i]);
  }
}
export function borrowingForm(element) {
  var bookListElement = element.querySelector('.book-list-container');
  var bookSelect = element.querySelector('.book-select');
  var bookSelectId = bookSelect.id;
  var userSelect = element.querySelector('.user-select');
  // let userSelectId = userSelect.id;
  var bookCopiesSelect = element.querySelector('.book-copies-select');
  var bookCopiesSelectId = bookCopiesSelect == null ? void 0 : bookCopiesSelect.id;
  var requestNotes = element.querySelector('.notes-textarea');
  var addBookToListBtn = element.querySelector('.add-book-to-list');
  var submitBtn = element.querySelector('.submit-btn');
  var actionType = element.dataset.type ? element.dataset.type : 'borrowing';
  var singleBookFormId = 'create-single-' + actionType + '-form';
  var multipleBooksFormId = 'create-multiple-' + actionType + '-form';
  function _getBookCopiesCount() {
    return bookListElement.querySelectorAll('.flex-data-item').length;
  }
  requestNotes == null ? void 0 : requestNotes.addEventListener("change", function (e) {
    e.preventDefault();
    element.querySelector('.notes').value = e.target.value;
  });
  userSelect.addEventListener("change", function (e) {
    e.preventDefault();
    element.querySelector('.userId').value = e.target.value;
  });
  addBookToListBtn.addEventListener("click", function (e) {
    e.preventDefault();
    var template;
    var bookId = bookSelect.value;
    var bookCopyId = bookCopiesSelect == null ? void 0 : bookCopiesSelect.value;
    var userId = userSelect.value;
    if (!bookId) return notification('warning', i18n.gettext('Book is required.'));
    if (!userId) return notification('warning', i18n.gettext('User is required.'));
    var book = adminConfig.bookCopies['book-' + bookId];
    if (actionType === 'request') {
      var bookCopyElement = document.getElementById('bookIdInput' + bookId);
      if (bookCopyElement) return notification('warning', i18n.gettext('This book is already in list.'));
      template = bookRequestTemplate(book);
    } else {
      if (!bookCopyId || bookCopyId === 'NULL') return notification('warning', i18n.gettext('There is no available copies.'));
      var _bookCopyElement = document.getElementById('bookCopyIdSelect' + bookCopyId);
      if (_bookCopyElement) return notification('warning', i18n.gettext('This copy is already in list.'));
      template = bookBorrowingTemplate(book, bookCopyId);
    }
    if (_getBookCopiesCount() === 1) {
      bookListElement.classList.remove('d-none');
    }
    if (!template) return;
    bookListElement.insertAdjacentHTML('beforeend', template);
    adminConfig.selects[bookSelectId].clear(true);
    simpleSelectInit('bookCopyIdSelect' + bookCopyId);
    if (bookCopiesSelect) {
      adminConfig.selects[bookCopiesSelectId].clear(true);
      adminConfig.selects[bookCopiesSelectId].clearOptions();
    }
    submitBtn.dataset.form = multipleBooksFormId;
  });
  document.addEventListener("click", function (e) {
    if (!e.target.matches(".delete-book-item")) return;
    var id = e.target.dataset.id;
    var bookCopyItem = document.getElementById('bookItem' + id);
    if (bookCopyItem) bookCopyItem.remove();
    if (_getBookCopiesCount() === 1) {
      bookListElement.classList.add('d-none');
      submitBtn.dataset.form = singleBookFormId;
    }
  });
}
function bookCopiesFormat(copies, copyId) {
  var markup = '',
    isSelected = false;
  for (var i = 0; i < copies.length; i++) {
    isSelected = parseInt(copyId, 10) === parseInt(copies[i].id, 10);
    markup += "<option value=\"" + copies[i].id + "\" " + (isSelected ? ' selected' : '') + ">#" + copies[i].id + " - " + copies[i].hash + "</option>";
  }
  return markup;
}
function bookBorrowingTemplate(book, copyId) {
  var _book$cover$sizes$med, _book$cover;
  if (!book) return;
  // const book = data;
  var mediumCover = (_book$cover$sizes$med = (_book$cover = book.cover) == null || (_book$cover = _book$cover.sizes) == null ? void 0 : _book$cover.medium) != null ? _book$cover$sizes$med : adminConfig.images.noCoverPath;
  return '<div class="flex-data-item" id="bookItem' + copyId + '">' + '<div class="flex-data-image">' + '<div class="lazy-container rounded">' + '<img class="rounded pe-none" src="' + mediumCover + '" alt="' + book.title + '" width="50" height="75">' + '</div>' + '</div>' + '<div class="flex-data-body" style="overflow: unset">' + '<div class="row align-items-center">' + '<div class="col-6 col-lg-5 mb-1">' + '<div class="flex-data-title">' + i18n.gettext('Book') + '</div>' + '<div class="flex-data-content">' + '<a class="text-reset fw-semibold" href="' + adminConfig.routes.bookEdit.replace('[bookId]', book.id) + '">' + book.title + (book.publishingYear ? ' (' + book.publishingYear + ')' : '') + '</a>' + '</div>' + '</div>' + '<div class="col-6 col-lg-6 mb-1">' + '<div class="flex-data-title">' + i18n.gettext('Copy') + '</div>' + '<div class="flex-data-content" style="overflow: unset">' + '<select name="bookCopyIds[]" id="bookCopyIdSelect' + copyId + '" class="form-select simple-select serialize-data" required>' + (book.copies ? bookCopiesFormat(book.copies, copyId) : '') + '</select>' + '</div>' + '</div>' + '<div class="col-lg-1"></div>' + '</div>' + '</div>' + '<div class="flex-data-action">' + '<div class="dropdown">' + getMoreBtn() + '<div class="dropdown-menu dropdown-menu-arrow dropdown-menu-end">' + '<button type="button" class="dropdown-item delete-book-item" data-id="' + copyId + '">' + i18n.gettext('Delete') + '</button>' + '</div>' + '</div>' + '</div>' + '</div>';
}
function bookRequestTemplate(book) {
  var _book$cover$sizes$med2, _book$cover2;
  if (!book) return;
  // let book = data.customProperties;
  var mediumCover = (_book$cover$sizes$med2 = (_book$cover2 = book.cover) == null || (_book$cover2 = _book$cover2.sizes) == null ? void 0 : _book$cover2.medium) != null ? _book$cover$sizes$med2 : adminConfig.images.noCoverPath;
  return '<div class="flex-data-item" id="bookItem' + book.id + '">' + '<div class="flex-data-image">' + '<div class="lazy-container rounded">' + '<img class="rounded pe-none" src="' + mediumCover + '" alt="' + book.title + '" width="50" height="75">' + '</div>' + '</div>' + '<div class="flex-data-body">' + '<div class="flex-data-content">' + '<a class="text-reset fw-semibold" href="' + adminConfig.routes.bookEdit.replace('[bookId]', book.id) + '">' + book.title + (book.publishingYear ? ' (' + book.publishingYear + ')' : '') + '</a>' + '<input type="hidden" name="bookIds[]" id="bookIdInput' + book.id + '" value="' + book.id + '">' + '</div>' + '<div class="flex-data-content">' + (book.ISBN ? book.ISBN : '-') + '</div>' + '<div class="flex-data-content">' + (book.authors ? getBookAuthors(book.authors) : '-') + '</div>' + '<div class="flex-data-content">' + (book.publisher ? book.publisher.name : '-') + '</div>' + '</div>' + '<div class="flex-data-action">' + '<div class="dropdown">' + getMoreBtn() + '<div class="dropdown-menu dropdown-menu-arrow dropdown-menu-end">' + '<button type="button" class="dropdown-item delete-book-item" data-id="' + book.id + '">' + i18n.gettext('Delete') + '</button>' + '</div>' + '</div>' + '</div>' + '</div>';
}